const Configuration = {
  apiPrefix: '',
  paymentUrl: '',
  statusRedirectUrl: '',
};

export default Configuration;
